var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "search-container" }, [
      _c(
        "div",
        { staticClass: "search-component" },
        [
          _vm.$root.isDesktop
            ? _c("search-component", {
                attrs: {
                  placeholder: "Search all fields",
                  "search-filter": _vm.currentSearchTextValue,
                  "handle-search-on-type": true,
                },
                on: { onSearch: _vm.handleFilterOrSearch },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "action-container" },
        [
          _c(
            "md-button",
            {
              staticClass: "md-primary",
              on: { click: _vm.navigateToCreateOrder },
            },
            [
              _c("md-icon", [_vm._v("add")]),
              _vm._v("\n                Create Order\n            "),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _vm.gridApi
            ? _c("grid-filter-manager", {
                attrs: {
                  "grid-api": _vm.gridApi,
                  "get-search-text": function () {
                    return _vm.currentSearchTextValue
                  },
                  "set-search-text": function (v) {
                    _vm.currentSearchTextValue = v
                    _vm.refreshServerSide()
                  },
                  "grid-url": "/api/orders/grid/saved",
                },
                on: { "default-filter-loaded": _vm.filterHasLoaded },
              })
            : _vm._e(),
        ],
        1
      ),
    ]),
    _c(
      "div",
      [
        _c("bulk-order-actions", {
          attrs: {
            "selected-orders": _vm.selectedRows,
            "actions-to-display": _vm.tableHeaderActionsToDisplay,
          },
          on: { "carrier-assign": _vm.handleCarrierAssign },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "grid-wrapper" },
      [
        _c("ag-grid-vue", {
          staticClass: "ag-theme-quartz",
          style: {
            width: "100%",
            height: _vm.isCarrierMarketplaceEnabled ? "75vh" : "85vh",
          },
          attrs: {
            "column-defs": _vm.columnDefs,
            "row-data": _vm.rowData,
            "default-col-def": _vm.defaultColDef,
            "grid-options": _vm.gridOptions,
            context: _vm.context,
          },
          on: {
            "grid-ready": _vm.onGridReady,
            "selection-changed": _vm.onSelectionChanged,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }